import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageLoading:false
  },
  getters: {
  },
  mutations: {
    set_pageLoading(state,value){
      state.pageLoading = value;
    }
  },
  actions: {
  },
  modules: {
  }
})
